<script lang="ts" setup>
import { ref } from 'vue'

import {
  EventStatusOverlay,
  QueueErrorStatusOverlay,
} from '@collector/shared-ui'
import { EventStatusId } from '@collector/sportsapi-client-legacy'
import { useEvent, useSportMaps } from '@desktop/views/Relation/composables'
import { injectEventIncidentsQueue } from '@desktop/views/Relation/provide-inject'
import { injectPitchOverlaySupportedStatuses } from '@desktop/views/Relation/Sports/provide-inject'

interface Props {
  isOnBottom?: boolean
}

defineProps<Props>()

// composables
const { event } = useEvent()
const { eventStatusToSportStatusMap } = useSportMaps()

// state
const queueErrored = ref(false)

// inject
const eventIncidentsQueue = injectEventIncidentsQueue()

// subscribe
eventIncidentsQueue.subscribeOnChange(({ errorQueueIncidents }) => {
  queueErrored.value = !!(errorQueueIncidents.length > 0)
})

// data
const supportedStatuses = injectPitchOverlaySupportedStatuses()

// methods
function getStatusName(statusId: EventStatusId): string {
  return eventStatusToSportStatusMap.value[statusId].name
}
</script>

<template>
  <QueueErrorStatusOverlay
    v-if="queueErrored"
    class="z-10 select-none"
    :class="{
      'top-1/3': isOnBottom,
    }"
  />
  <template v-else>
    <template
      v-for="(status, index) in supportedStatuses"
      :key="`event-status-overlay-${index}`"
    >
      <EventStatusOverlay
        v-if="event.status_id === status"
        class="select-none"
        :class="{
          'top-1/3': isOnBottom,
        }"
      >
        {{ getStatusName(status) }}
      </EventStatusOverlay>
    </template>
  </template>
</template>
